import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, ImageResizeResponse } from '../types/showcase';

/**
 * C080 이미지 데모(순수 변환) — POST .../image/resize (multipart · queue #646 §R646-2).
 * ★file 은 optional — 미첨부 시 BE 가 번들 샘플 이미지를 사용한다(CommonShowcaseImageDemoService).
 */
export function useImageResize() {
  return useMutation<ImageResizeResponse, ApiError, { file?: File | null; width: number; height: number }>({
    mutationFn: ({ file, width, height }) => showcaseApi.imageResize(width, height, file),
    mutationKey: ['common-showcase', 'image', 'resize'],
  });
}
